import { post } from '@tencent/pmd-network';

export function setUserInfo({ head, nick, customize = true }) {
  return new Promise((resolve, reject) => {
    const reqData = {
      nick: String(nick || ''),
      header: String(head || ''),
      customize,
    };
    post({
      url: '/pvpesport.sgamenes.commcgi.commcgi/SetUserInfo',
      reqData,
    })
      .then((response) => {
        if (response.r == 0) {
          resolve();
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function getUserInfo() {
  return new Promise((resolve, reject) => {
    const reqData = {};
    post({
      url: '/pvpesport.sgamenes.commcgi.commcgi/GetPmdUserInfo',
      reqData,
    })
      .then((response) => {
        const result = {
          nick: '',
          head: '',
          valid: false, // 头像是否有效，已自动获取或者自定义过
        };
        if (response.r == 0) {
          result.head = response.user_info?.header || '';
          result.nick = response.user_info?.nick || '';
          const hasCustom = response.user_info?.customize_nick_header == true;
          const invalidNick = result.nick == '' || result.nick == '微信用户' || result.nick == 'QQ用户';
          result.valid = hasCustom || !invalidNick;
          resolve(result);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function checkBindPlat(reqData = {}) {
  return post({
    url: '/pvpesport.sgamenes.commcgi.commcgi/CheckBindPlat',
    reqData,
  });
}

export function autoBindPlatUserInfo(reqData = {}) {
  return post({
    url: '/pvpesport.sgamenes.commcgi.commcgi/AutoBindPlatUserInfo',
    reqData,
    showMsgToast: true,
  });
}

export function getOpenidBindCode(reqData) {
  return post({
    url: '/pvpesport.sgamenes.commcgi.commcgi/GetOpenIdBindCode',
    reqData,
  });
}


export function submitQuestionnaire(reqData) {
  return post({
    url: '/pvpesport.sgamenes.nesplayer.nesplayer/OpCustomInfo',
    reqData,
    showMsgToast: false,
  });
}
